<template>
  <portlet
      :icon="'fad fa-door-open'"
      :title="'Stoppers'"
      :actionsBlock="true"
  >
    <template slot="actionsBlock">
      <!--      <router-link tag="button" :to="{name:'candidate-create'}" class="btn btn-secondary">-->
      <!--        <i class="fas fa-plus-circle mr-2"></i> Toevoegen-->
      <!--      </router-link>-->
      <!--      <a @click="createGroupSMS()">-->
      <!--        <button class="btn btn-primary mr-4">-->
      <!--          <i class="fal fa-sms mr-2"></i>{{this.getUserData.id == 32 ? 'SEXTING' : 'SMS verzenden' }}-->
      <!--        </button>-->
      <!--      </a>-->
      <!--      <a :href="$CLOUD_API+'/export/candidates?access_token=' + this.$store.state.oAuthToken" v-if="isAdmin">-->
      <!--        <button class="btn btn-primary mr-4">-->
      <!--          <i class="fas fa-file-excel mr-2"></i> Exporteren naar Excel-->
      <!--        </button>-->
      <!--      </a>-->

      <a @click="reset()">
        <button class="btn btn-primary mr-4">
          <i class=" fas fa-sync"></i> reset filter
        </button>
      </a>


    </template>

    <template slot="portletBody">
      <button class="m-show-lg btn btn-secondary w-100 mb-4" @click="filterOpen = !filterOpen">
        <i class="far mr-3" :class="{'fa-filter': !filterOpen, 'fa-times': filterOpen }"></i>
        <template v-if="!filterOpen">
          Filter kandidaten
        </template>
        <template v-else>
          Sluit filter
        </template>
      </button>


      <div class="row dataTable-filters mb-5" :class="filterOpenClass">
        <div class="col-md-4 col-xl-2">
          <date-range-picker
              ref="picker"
              v-model="picker"
              opens="center"
              :maxDate="maxDate"
              :showDropdowns="true"
              :autoApply="true"
              :locale-data="this.locales"
              :ranges="this.ranges"
              @update="updateDateRange"
          >
            <template slot="input" slot-scope="picker">
              <i class="fad fa-calendar"></i> <label>Uitdienstdatum</label>
            </template>
          </date-range-picker>
        </div>

        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Geslacht </span>
            </button>
            <div class="dropdown-menu">

              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(gender, index) in ['Man','Vrouw','Ik weet het nog niet']"
                     :key="gender+'-'+index">
                  <input v-model="customFilters[6].options.values"
                         :value="gender"
                         type="checkbox"
                         :id="gender+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="gender+'-'+index">
                    <span>{{ gender }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              <span>Persoon ({{ customFilters[0].options.values.length }})</span>
            </button>
            <div class="dropdown-menu">
              <input class="form-control mb-3" type="text" placeholder="Zoeken.."
                     v-model="searchName">
              <div class="option-wrapper">
                <div class="custom-control custom-checkbox"
                     v-for="(candidate, index) in searchByName"
                     :key="candidate+'-'+index">
                  <input v-model="customFilters[0].options.values"
                         :value="candidate.id"
                         type="checkbox"
                         :id="candidate.fullName+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="candidate.fullName+'-'+index">
                    <span>{{ candidate.fullName }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Ervaring ({{ customFilters[1].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="option-wrapper-large">
                <div class="custom-control custom-checkbox"
                     v-for="(experience, index) in getExperiences"
                     :key="experience+'-'+index">
                  <input v-model="customFilters[1].options.values"
                         :value="experience"
                         type="checkbox"
                         :id="experience+'-'+index"
                         class="custom-control-input"
                  >
                  <label class="custom-control-label" :for="experience+'-'+index">
                    <span>{{ experience }}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Ploegen ({{ customFilters[2].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(shift, index) in getStandardFormChoices('shifts')"
                   :key="shift+'-'+index">
                <input v-model="customFilters[2].options.values"
                       :value="shift"
                       type="checkbox"
                       :id="'shift-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="'shift-'+index">{{ shift }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2 salary-range-filter">
          <label for="salaryRange" class="mb-1">Salaris Min</label>
           <vue-slider
              v-model="salaryMin"
              id="salaryRange"
              :min="1"
              :max="getSalaryMin"
              :interval="0.5"
              :tooltip="'always'"
              :tooltip-placement="'bottom'"
              :silent="true"
              @change="setValueSalary"
          >
          </vue-slider>
        </div>
      </div>
      <div class="row dataTable-filters mb-5" :class="filterOpenClass">

        <div class="col-md-4 col-xl-2">
          <div class="dropdown">
            <button class="btn btn-primary dropdown-toggle" type="button">
              Vervoer ({{ customFilters[4].options.values.length }})
            </button>
            <div class="dropdown-menu">
              <div class="custom-control custom-checkbox"
                   v-for="(transport, index) in getStandardFormChoices('transports')"
                   :key="transport+'-'+index">
                <input v-model="customFilters[4].options.values"
                       :value="transport"
                       type="checkbox"
                       :id="transport+'-'+index"
                       class="custom-control-input"
                >
                <label class="custom-control-label" :for="transport+'-'+index">
                  <span>{{ transport }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-xl-2">
          <input id="getGeoLocation"
                 type="text"
                 class="form-control"
                 :class="{'is-invalid': checkZipCode}"
                 v-model.trim="zipcode"
                 placeholder="1234 AB"
          >
          <span v-if="checkZipCode" class="small text-danger">Postcode is onjuist</span>
        </div>
      </div>
      <div class="modal fade" id="group-sms" aria-labelledby="group-sms" tabindex="-1" role="dialog"
           aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered lg">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">Groep sms</h4>
              <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            </div>
            <div class="modal-body">
              <p>Bericht wordt verzonden aan <b>{{ smsCandidates.length }}</b> candidaten</p>
              <label for="message">Bericht <span
                  style="opacity:0.5">nog {{
                  smsMessageLength - smsMessage.length >= 0 ? smsMessageLength - smsMessage.length : 0
                }} karakters vereist </span></label>
              <textarea name="message" v-model="smsMessage" id="message" cols="30" rows="10"
                        class="form-control"></textarea>
            </div>
            <div class="modal-footer">
              <button type="button" @click="sendSms()" class="btn btn-primary">Verstuur SMS</button>
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
       <datatables
          :tableClass="tableClass"
          v-if="getCandidates.length && renderedComponent"
          :rows="getStoppedCandidates(includeBlacklistedCandidates, startDate, endDate)"
          :columns="columns"
          tableID="quitters"
          :tableInitOptions="tableInitOptions"
          :customFilters="customFilters"
          routerLinkClass="dt-router-link"
          :deleteFunction="deleteCandidate"
          deleteClass="delete"
          @rowSelected="searchVacancy"
      ></datatables>


    </template>

  </portlet>
</template>

<script>
import {mapGetters} from 'vuex';
import {getGeoLocation} from '../../components/mixins/getGeoLocation';
import {dataTables} from '../../components/mixins/dataTables';
import {swalModals} from '../../components/mixins/swalModals.js';


export default {
  name:'Quitters',
  mixins: [getGeoLocation, dataTables, swalModals],
  data() {
    return {
      includeBlacklistedCandidates: false,
      maxDate: moment().endOf('day').toDate(),
      picker: {
        startDate: moment().startOf('month').toDate(),
        endDate: moment().endOf('day').toDate(),
      },
      startDate: moment().startOf('month').toDate(),
      endDate: moment().endOf('day').toDate(),
      locales: {
        direction: 'ltr',
        format: moment.localeData().longDateFormat('L'),
        separator: ' - ',
        applyLabel: 'Opslaan',
        cancelLabel: 'Annuleren',
        weekLabel: 'W',
        customRangeLabel: 'Bereik afspraken',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: moment.localeData().firstDayOfWeek()
      },
      ranges: {
        'Vandaag': [moment().startOf('day').subtract(1, 'day'), moment().endOf('day')],
        'Gisteren': [moment().subtract(1, 'days').subtract(1, 'day').startOf('day'), moment().subtract(1, 'days').endOf('day')],
        'Deze week': [moment().startOf('week').subtract(1, 'day'), moment().endOf('day')],
        'Deze maand': [moment().startOf('month').subtract(1, 'day'), moment().endOf('day')],
        'Dit jaar': [moment().startOf('year').subtract(1, 'day'), moment().endOf('day')],
        'Vorige week': [moment().subtract(1, 'week').subtract(1, 'day').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'Vorige maand': [moment().subtract(1, 'month').subtract(1, 'day').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        // 'Toekomst': [moment().subtract(1, 'day').startOf('day'), moment().add(100, 'years').endOf('day')],
        'Historie': [moment().subtract(50, 'year').startOf('year'), moment().endOf('day')]
      },
      isAdmin: false,
      filterOpen: false,
      filterOpenClass: 'm-hide-lg',
      searchName: '',
      salaryMin: null,
      zipcode: null,
      checkZipCode: false,
      columns: [
        {
          data: null, name: 'Persoon', visible: true, searchable: true, responsivePriority: 1,
          render(data) {
            return '<a data-to="/candidates/' + data.id + '" class="dt-router-link">' + data.firstName + ' ' + data.lastName + '</a>';
          }
        },
        {data: 'experiences[, ]', name: 'Ervaringen', visible: true, searchable: true},
        {data: 'shifts[, ]', name: 'Ploegen', visible: true, searchable: true},
        {
          data: 'travelDistance', name: 'Max. afstand', visible: true, searchable: true,
          render(data,type) {
            if (type !== 'display') {
              return parseFloat(data);
            } else {
              return data + ' km';
            }
          }
        },
        {
          data: null, name: 'Salaris', visible: true, searchable: true,
          render(data) {
            return '€ ' + (data.salaryMin ? data.salaryMin : '') ;
          }
        },
        {data: 'transports[, ]', name: 'Vervoer', visible: true, searchable: true},
        {
          data: 'sick', name: 'Ziek', visible: true,
          render(data) {
            if (data) {
              return '<i class="fas fa-user-md" title="Kandidaat is ziek"></i>';
            } else {
              return '';
            }

          }
        },
        {
          data: 'quittedDate', name: 'Uit dienst op', visible: true, sortable: true,
          render(data) {
            if (data) {
              return moment(data).format('DD-MM-YYYY');
            } else {
              return '';
            }

          }
        },
        {
          data: null, name: 'Opties', orderable: false, responsivePriority: 2,
          render(data) {
            if (data.blacklisted) {
              return '<a data-to="/candidates/' + data.id + '" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-edit"></i></a>' +
                  '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>' +
                  '<i title="Staat op blacklist" class="far fa-exclamation-triangle action-icon"></i>';
            } else {
              return '<a data-to="/candidates/' + data.id + '" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-edit"></i></a>' +
                  '<a class="delete action-icon " data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>' +
                  '<i title="Vacature zoeken" class="far fa-search action-icon get-data"></i>';
            }
          }
        },

        {data: 'geoLocation.lat', name: 'geoLat', visible: false, searchable: false},
        {data: 'geoLocation.lng', name: 'geoLng', visible: false, searchable: false}
      ],
      customFilters: [
        {
          filter: 'arrayContains',
          keyToFilter: 'id',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'arrayHas',
          keyToFilter: 'experiences',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'shifts',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'greaterThan',
          keyToFilter: 'salaryMin',
          options: {
              min: 1,
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'transports',
          options: {
            keyToFilter: null,
            values: []
          }
        },
        {
          filter: 'getDistanceFromGeoCoord',
          keyToFilter: 'geoLocation',
          keyToFilterRange: 'travelDistance',
          options: {
            range: {max: 0, min: 0},
            coordsFrom: null
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'gender',
          options: {
            keyToFilter: null,
            values: []
          }
        },
      ],
      smsMessage: '',
      smsMessageLength: 20,
      smsCandidates: []
    };
  },
  methods: {
    setValueSalary(value) {
        console.log(value)
      this.customFilters[3].options.min = value;
      return value;
    },
    updateDateRange(dateRange) {
      this.startDate = moment(dateRange.startDate).startOf('day').toDate()
      this.endDate = moment(dateRange.endDate).endOf('day').toDate()
    },
    deleteCandidate(data) {
      let name = data.firstName + ' ' + data.lastName;
      this.swalDelete(name).then(result => {
        if (result.value) {
          this.$store.dispatch('candidates/delete', data.id).then(() => {
            this.renderComponent();
            this.$toasted.global.successRequest({
              message: 'Kandidaat verwijderd'
            });
          });
        }
      });
    },
    reset() {
      this.resetFilter(['quitters-filter-state']);
      this.zipcode = '';
      this.salaryMin = this.getSalaryMin;

      this.picker.startDate = moment('2010-01-01').toDate();
      this.picker.endDate = moment('2010-01-01').toDate();
      this.startDate = moment('2010-01-01').toDate();
      this.endDate = moment().endOf('day').toDate();
      document.dispatchEvent(new CustomEvent('dataTables-searchProgrammatically'));
    },
    searchVacancy(value) {
      let candidateObj = value;
      this.$router.push({name: 'vacancies', params: {candidateObj}});
    },
    createGroupSMS() {
      this.smsCandidates = $('#candidates').DataTable().rows({filter: 'applied'}).data().toArray();

      if (this.smsCandidates.length < 1) {
        this.$toasted.global.failedRequest({message: 'Geen candidaten'});
      } else {
        $('#group-sms').modal('show');
      }
    },
    sendSms() {
      if (this.smsMessage.length < 20) {
        return this.$toasted.global.failedRequest({message: 'TE KORTE SMS'});
      }
      if (this.smsCandidates.length < 1) {
        this.$toasted.global.failedRequest({message: 'Geen candidaten'});
      }
      let smsData = {
        candidates: this.smsCandidates.map(candidate => {
          return {id: candidate.id, telephone: candidate.telephone};
        }),
        status: 'pending',
        message: this.smsMessage,
        department: this.$store.getters.getUserData.selectedDepartment,
        sentBy: this.getUserData
      };
      this.$store.dispatch('smsHistory/insert', smsData).then(response => {
        $('#group-sms').modal('hide');
        this.smsMessage = '';
        this.smsCandidates = [];
        this.$toasted.global.successRequest({message: 'SMS aangemaakt en wacht op verzending'});
      });
    }
  },
  computed: {
    ...mapGetters([
      'getUserData'
    ]),
    ...mapGetters('candidates', [
          'getCandidates',

          'getStandardFormChoices',
          'getCandidateFullName',
          'getExperiences',
          'getSalaryMin',
          'getSalaryMinMax',
          'getStoppedCandidates'
        ]
    ),
    ...mapGetters('customers', ['getCustomers']),
    searchByName() {
      return this.getCandidateFullName.filter((search) => {
        return search.fullName.toLowerCase().indexOf(this.searchName.toLowerCase()) >= 0;
      });
    }
  },
  watch: {
    'filterOpen': function (value) {
      if (value) {
        this.filterOpenClass = 'm-show-flex-lg';
      } else {
        this.filterOpenClass = 'm-hide-lg';
      }
    },
    salaryMin(after) {
      localStorage.setItem('quitters-filter-state', JSON.stringify(this.customFilters));
    },
    'getSalaryMin': function () {

      this.salaryMin = this.getSalaryMin;
    },
    'zipcode': function (zipcode) {
      let regex = new RegExp('^[1-9][0-9]{3}\s?([a-zA-Z]{2})?$');

      let trimmedZip = zipcode.replace(/\s/g, '');
      if (trimmedZip.length === 6 && regex.test(trimmedZip)) {
        this.getGeoLocationfromPostal(trimmedZip).then((res) => {
          let geoData = res.data.results[0];
          if (geoData) {
            this.customFilters[5].options.coordsFrom = geoData.geometry.location;
            this.checkZipCode = false;
          } else {
            this.checkZipCode = true;
          }
        });
      } else if (trimmedZip.length > 6) {
        this.checkZipCode = true;
      } else {
        this.customFilters[5].options.coordsFrom = null;
      }
    },
    'customFilters': {
      handler: function (after, before) {
        //store daterange
        localStorage.setItem('quitters-filter-state', JSON.stringify(after));

      },
      deep: true
    }
  },
  created() {
    this.isAdmin = this.$store.state.users.me.admin;
    let vacancyObj = this.$route.params.vacancyObj;

    if (vacancyObj) {
      this.customFilters[1].options.values = vacancyObj.experiences.filter(i => this.getExperiences.indexOf(i) !== -1);
      this.customFilters[2].options.values = vacancyObj.shifts;
      this.customFilters[3].options.min = vacancyObj.salaryFrom;
      this.salaryMinMax = [parseInt(vacancyObj.salaryFrom), parseInt(vacancyObj.salaryTo)];
      this.customFilters[5].options.coordsFrom = vacancyObj.geoLocation;

      this.zipcode = vacancyObj.zipcode;
    } else {
      let customFilterState = localStorage.getItem('quitters-filter-state');
      if (customFilterState) {
        this.customFilters = JSON.parse(customFilterState);
        if (!this.customFilters[6]) {
          this.customFilters.push(
              {
                filter: 'arrayContains',
                keyToFilter: 'gender',
                options: {
                  keyToFilter: null,
                  values: []
                }
              })
        }
        let salary = this.customFilters[3].options;
        if (salary.max === 999999999 && salary.min === 0) {
          this.salaryMin = this.getSalaryMin;
        } else {
          this.salaryMin =  salary.min;
        }
      } else {
        this.salaryMin = this.getSalaryMin;
      }

    }
    // this.renderComponent()
  }
};
</script>
